import styled from 'styled-components'

export const TabsListContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`
